module.exports = __webpack_public_path__ + "static/media/_confirm.c41cbecc.svg";